module.exports = __webpack_public_path__ + "img/logo_sp.f4a9ed81.png";